import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinboribel() {



const cardData =
  {
    keyword: 'Bus On Rent in Boribel',
    heading: 'Sanavi Travels: Bus On Rent in Boribel',
    headingDescription: 'Sanavi Travels offers reliable, safe, and professionally managed Bus On Rent in Boribel, catering to families, wedding groups, corporate teams, schools, picnic travelers, religious devotees, and outstation passengers. Boribel is a village located near Daund taluka in Pune district, surrounded by agricultural lands and connected to Daund town, Baramati, Shrigonda, and the Pune–Solapur region. Due to frequent weddings, social gatherings, religious programs, school activities, and long-distance travel needs, organized group transportation is essential in Boribel. To meet these diverse requirements, we provide a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and large seating-capacity buses suitable for short village routes as well as long outstation journeys. Every bus is maintained with clean interiors, cushioned seating, smooth suspension, proper ventilation, and adequate luggage space, ensuring a comfortable and safe travel experience for passengers of all age groups. Our experienced drivers are well acquainted with Boribel village roads, nearby rural routes, Daund town connectivity, and major highways, ensuring punctual pickups, disciplined driving, and smooth navigation even on interior roads. With flexible rental packages, transparent pricing, and 24/7 customer support, Sanavi Travels makes bus rental in Boribel affordable, convenient, and completely stress-free for every travel occasion.',

    top: 'Top Places to Visit Near Boribel with Sanavi Travels',


"topPlaces": [
  {
    "title": "Boribel Village Area",
    "description": "Boribel is a calm rural village known for its close-knit community, agricultural lifestyle, and frequent social functions. Weddings, religious events, and family gatherings are common, creating regular demand for group transportation. Bus rentals help villagers and guests travel together comfortably while avoiding coordination issues with multiple vehicles."
  },
  {
    "title": "Daund Town Connectivity",
    "description": "Daund town serves as the nearest major commercial and transport hub for Boribel residents. People regularly travel to Daund for markets, hospitals, railway access, and administrative work. Bus hire services ensure safe, organized, and punctual group travel between Boribel and Daund."
  },
  {
    "title": "Agricultural Surroundings",
    "description": "Boribel is surrounded by fertile farmland where sugarcane, grains, and seasonal crops are cultivated. Farmers and cooperative members often travel together for meetings, market visits, and agricultural programs. Bus rentals provide economical and comfortable transportation across rural roads."
  },
  {
    "title": "Nearby Temples and Spiritual Sites",
    "description": "Local temples and religious centers around Boribel attract devotees during festivals and special occasions. Bus hire services are commonly used for group temple visits, ensuring peaceful, coordinated, and stress-free travel for devotees."
  },
  {
    "title": "School and Educational Travel",
    "description": "Students from Boribel frequently travel to nearby towns for school programs, competitions, educational tours, and cultural activities. Bus rentals provide safe, supervised, and punctual transportation for students and teachers."
  },
  {
    "title": "Wedding and Event Venues",
    "description": "Marriage halls and open venues in and around Boribel generate strong demand for guest transportation. Hiring buses ensures guests arrive together and on time, reducing parking issues and improving event coordination."
  },
  {
    "title": "Picnic and Leisure Destinations",
    "description": "Families, schools, and organizations from Boribel often plan picnic trips to nearby destinations. Bus rentals allow everyone to travel together safely while enjoying the journey without travel stress."
  },
  {
    "title": "Pune–Solapur Road Access",
    "description": "Boribel has convenient access to the Pune–Solapur road network, making it suitable for long-distance travel. Bus rentals provide stability, comfort, and cost efficiency for highway journeys."
  },
  {
    "title": "Industrial and Work Travel",
    "description": "Many residents travel to Daund, Baramati, and nearby industrial areas for employment. Bus hire services support organized employee transportation and group commuting."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Boribel serves as a starting point for outstation journeys to Pune, Solapur, Ahmednagar, and pilgrimage destinations. Bus rentals offer a comfortable and economical solution for long-distance group travel."
  }
]
,



"services": [
{
"name": "Bus On Rent in Boribel",
"description": "Bus On Rent in Boribel provides safe, spacious, and professionally managed buses for families, schools, corporate groups, and social events. This service is ideal for weddings, religious programs, picnics, school trips, and outstation travel. Our buses feature clean interiors, cushioned seating, smooth suspension, proper ventilation, and ample luggage space, ensuring passenger comfort even on long journeys. Experienced drivers ensure punctual pickups, disciplined driving, and smooth navigation across village roads and highways, making group travel well organized and stress-free."
},
{
"name": "Bus Hire Boribel",
"description": "Bus Hire Boribel offers flexible rental options for local travel, full-day use, and long-distance journeys. With reliable buses and professional drivers, group transportation becomes efficient, safe, and economical."
},
{
"name": "AC Bus Rental Boribel",
"description": "AC Bus Rental Boribel is ideal for summer travel and long-distance trips, providing air-conditioned comfort, relaxed seating, and reduced travel fatigue for passengers."
},
{
"name": "Non AC Bus on Rent Boribel",
"description": "Non AC Bus on Rent Boribel provides cost-effective transportation for short routes, rural travel, school trips, and local group movement without compromising safety."
},
{
"name": "Luxury Bus on Rent Boribel",
"description": "Luxury Bus on Rent Boribel delivers a premium travel experience with modern interiors, superior seating, and enhanced comfort, suitable for weddings, VIP guests, and corporate travel."
},
{
"name": "Mini Bus Hire Boribel",
"description": "Mini Bus Hire Boribel is suitable for small to medium-sized groups such as families, office teams, and student groups, offering flexibility and affordability."
},
{
"name": "32 Seater Bus on Rent Boribel",
"description": "32 Seater Bus on Rent Boribel is ideal for school excursions, corporate outings, and medium-sized group travel, balancing seating capacity with comfort."
},
{
"name": "35 Seater Bus Hire Boribel",
"description": "35 Seater Bus Hire Boribel supports large group transportation needs such as weddings, religious tours, and long-distance travel."
},
{
"name": "Bus on Rent Boribel for Wedding",
"description": "Bus on Rent Boribel for Wedding ensures coordinated and timely transportation for wedding guests, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus on Rent Boribel for Corporate",
"description": "Bus on Rent Boribel for Corporate provides professional transportation for employee movement, meetings, conferences, and corporate outings."
},
{
"name": "Bus on Rent Boribel for Picnic",
"description": "Bus on Rent Boribel for Picnic offers safe and enjoyable group travel for schools, families, and organizations planning leisure trips."
},
{
"name": "Bus Rental Boribel Outstation",
"description": "Bus Rental Boribel Outstation provides dependable long-distance transportation to Pune, Daund, Baramati, Solapur, and nearby cities."
},
{
"name": "Bus Hire Boribel with Driver",
"description": "Bus Hire Boribel with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules efficiently."
},
{
"name": "Affordable Bus Rental Boribel",
"description": "Affordable Bus Rental Boribel delivers budget-friendly transportation without compromising cleanliness, comfort, or reliability."
},
{
"name": "Best Bus Service Boribel",
"description": "Best Bus Service Boribel is trusted for punctual service, clean buses, transparent pricing, and customer satisfaction delivered by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Boribel", "Bus Hire Boribel"],
["AC Bus Rental Boribel", "Non AC Bus Hire Boribel"],
["Luxury Bus Boribel", "Mini Bus Hire Boribel"],
["32 Seater Bus Boribel", "35 Seater Bus Boribel"],
["Wedding Bus Boribel", "Corporate Bus Boribel"],
["Picnic Bus Boribel", "Outstation Bus Boribel"],
["Bus Hire Boribel with Driver", "Affordable Bus Rental Boribel"],
["Best Bus Service Boribel", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Boribel with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and professional bus rental services in Boribel for all group travel needs."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "All buses are regularly maintained and cleaned to ensure passenger comfort."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Boribel, Daund, rural routes, and highways."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, full-day, and outstation rental plans available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every journey."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Boribel?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Boribel.'
  },
  {
    question: 'What types of buses are available in Boribel?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus rental available for weddings and picnics?',
    answer: 'Yes, we provide dedicated buses for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Boribel?',
    answer: 'Yes, outstation bus rentals are available from Boribel.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ganesh Khandagale',
    feedback: 'We booked a bus from Boribel for a wedding. Very comfortable and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shital More',
    feedback: 'Sanavi Travels provided a clean bus for our picnic from Boribel. Smooth journey overall.',
    rating: 5
  }
];




















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Boribel - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Boribel for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Boribel | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Boribel with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/233.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinboribel;